jQuery(document).ready(function($){

  $(function() {
    var list = $('.Custom_Dropdown_List');
    var link = $('.Js_Link');
    
    var mobactiveIndex = $('.active-tab').index(),
        $mobcontentlis = $('.tabs-content > div'),
        $mobtabslis = $('.Custom_Dropdown_List li');
  
    link.click(function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      list.slideToggle(200);
    });
    
    list.find('li').click(function(e) {    
      var text = $(this).html();
      var icon = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 0.5L6 5.5L1 0.5" stroke="black" stroke-width="1.25"/> </svg>';
      link.html(text+icon);
      list.slideToggle(200);
      if (text === '* Reset') {
        link.html('Select one option'+icon);
      }
  
      var $mobcurrent = $(e.currentTarget),
          mobindex = $mobcurrent.index();
      $mobcontentlis.hide().eq(mobindex).show();
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  function updateAllNostoEmptyClasses() {
    const nostoSections = document.querySelectorAll('.nosto-custom-section');

    nostoSections.forEach(function(section) {
      const nostoElement = section.querySelector('.nosto_element');

      if (nostoElement) {
        if (nostoElement.innerHTML.trim() === '') {
          section.classList.add('nosto__empty');
        } else {
          section.classList.remove('nosto__empty');
        }
      }
    });
  }

  // Run once on page load
  updateAllNostoEmptyClasses();

  // Observe each .nosto_element individually
  const nostoElements = document.querySelectorAll('.nosto-custom-section .nosto_element');

  nostoElements.forEach(function(nostoElement) {
    const observer = new MutationObserver(updateAllNostoEmptyClasses);
    observer.observe(nostoElement, { childList: true, subtree: true });
  });
});

